module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_157.5deg.369cd687.png";